class MiniCart {
  async validateCheckoutDiscount() {
    const cart = await fetch("/cart.js").then(response => response.json());
    const checkoutButton = document.querySelector(".button__atc--checkout");
    if(cart.total_price > 1000) {
      checkoutButton.href = "/checkout?discount=FREE_SHIPPING_REWARD";
    }else {
      checkoutButton.href = "/checkout";
    }
  }
}

const miniCart = new MiniCart();

$(document).on("cart.requestComplete", () => {
  miniCart.validateCheckoutDiscount()
})